import { widget } from "@foretagsplatsen/widgetjs";
import KeyFigureChartWidget from "../shared/KeyFigureChartWidget.js";
import keyFigureValueWidget from "../shared/keyFigureValueWidget.js";

/**
 * `singleKeyFigureReportWidget` is a card for a single KeyFigure gathering a value widget
 * and a chart widget related to the key-figure.
 *
 * @param {object} spec - Parameter object
 * @param {number} spec.numPeriods - number of periods to use in order to show the data
 * @param {keyFigure} spec.keyFigure - keyFigure to display
 * @param {object} my - protected fields holder
 * @return {*}
 */
function singleKeyFigureReportWidget(spec, my) {
	spec ||= {};
	my ||= {};
	const that = widget(spec, my);

	const keyFigure = spec.keyFigure;

	my.keyFigureValue = keyFigureValueWidget({
		navigateToSingleKeyFigure: true,
	});

	my.keyFigureChart = new KeyFigureChartWidget({
		showTooltip: false,
	});

	my.keyFigureChart.initialize();

	my.keyFigureChart.onPlotbandHovered.register((plotband) => {
		my.keyFigureValue.setCurrentValue(plotband.options.data);
	});

	my.keyFigureChart.onPlotbandExited.register(() => {
		my.keyFigureValue.setCurrentValue();
	});

	my.keyFigureChart.onPlotbandClick.register((plotBand) => {
		my.redirectTo("single-kpi", {
			keyFigure: keyFigure.getId(),
			period: plotBand.options.period.toString(),
		});
	});

	my.keyFigureChart.onPointClick.register((point) => {
		my.redirectTo("single-kpi", {
			keyFigure: keyFigure.getId(),
			period: point.options.period.toString(),
		});
	});

	that.getKeyFigure = function () {
		return keyFigure;
	};

	that.showEntries = function (result) {
		my.keyFigureValue.setResult(result);
		my.keyFigureChart.setResult(result);
		that.update();
	};

	that.setNumberOfPeriods = function () {
		that.show();
	};

	that.renderContentOn = function (html) {
		html.h2(keyFigure.getName());

		html.div(
			{ klass: "row" },
			html.div({ klass: "col-md-4" }, my.keyFigureValue),
			html.div({ klass: "col-md-8" }, my.keyFigureChart),
		);
	};

	return that;
}

export default singleKeyFigureReportWidget;
